<script setup lang="ts">
const route = useRoute()
useHead({
  titleTemplate: () => {
    return 'Workforce Development Institute'
  }
})
const globalStore = useGlobalStore();
const maintenanceModeEnabled = ref<boolean>(false);
const containerKey = ref(0);
const maintenanceKey = ref(0);

watch(() => globalStore.isMaintenanceModeEnabled, async (newVal) => {
  maintenanceModeEnabled.value = !!newVal;
  maintenanceKey.value += 1;
});

onMounted(async () => {
  globalStore.fetchCspStatus();
  globalStore.startPolling();
  maintenanceKey.value += 1;
  containerKey.value += 1;
  }
)
</script>
<template>
    <UContainer v-if="!maintenanceModeEnabled" :key="containerKey">
        <div class="flex flex-col md:flex-row justify-between space-y-4 items-center pt-5 mb-5 md:mb-10 px-2 md:px-10 xl:px-20">
            <img src="/wdi-logo-rgb.png" alt="WDI Logo" class="h-12 md:h-20 flex-none">
            <span class="block font-bold text-xl md:text-2xl text-gray-700">{{ $t(route.meta.title) }}</span>
        </div>
        <slot />
    </UContainer>
    <MaintenanceModeMessage v-else-if="maintenanceModeEnabled" :key="maintenanceKey" :is-public-page="true" />  
</template>